import React from "react"

export const BulkOrders = () => {
    return (
    <div className="support-faq container py-4">
        <h3>Bulk Orders</h3>
    </div>
    );
}